import React from "react";
import "./form.scss";
import { InputType } from "../../../types/UITypes";

interface Props {
	label?: string | null;
	name: string; // for formik to use
	id: string;
	className?: string;
	placeholder?: string | null;
	type?: InputType;
	accept?: string;
	value: string;
	onChange: (value: any) => void;
	required?: boolean;
	errors?: string;
	touched?: boolean;
	autocomplete?: string;
}

const Input = ({
	label,
	id = "input",
	className,
	placeholder = "",
	type = InputType.Text,
	accept,
	value,
	onChange,
	required = false,
	name,
	errors,
	touched,
	autocomplete,
	...rest
}: Props) => (
	<div className="formFieldLabel" {...rest}>
		{label || (touched && errors) ? (
			<label htmlFor={id}>
				{label}
				{
					label && (touched && errors) ? (
						<>&nbsp;·&nbsp;</>
					) : null
				}
				{touched && errors ? (
						<span className="errorText">{errors}</span>
				) : null}
			</label>
		) : null}
		<input
			id={id}
			type={type}
			accept={accept}
			value={value}
			onChange={onChange}
			className={["input", className]?.join(" ")}
			placeholder={placeholder ?? ""}
			required={required}
			name={name}
			autoComplete={autocomplete}
		/>
	</div>
);

export default Input;
